import VueRouter from 'vue-router';
import PublicationsList from './PublicationsList.vue';
import { sync } from 'vuex-router-sync';
import Vue from 'vue';

Vue.use(VueRouter);

export function createRouter(store) {
	const router = new VueRouter({
		base: store.state.baseUrl,
		mode: 'history',
		routes: 
		[
			{
				name: 'publications',
				path: `/defense/:page(\\d+)?`,
				component: PublicationsList
			},
			{
				name: 'publicationsWithArea',
				path: `/defense/filter/:areaUrlCode/:page(\\d+)?`,
				component: PublicationsList
			}
		]
	});
	sync(store, router);
	return router;
}